import React from 'react';
import PropTypes from 'prop-types';
import MorePropTypes from 'airbnb-prop-types';
import { withStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import CopyToClipboard from 'components/CopyToClipboard/CopyToClipboard';
import ORTypography from 'components/ORTypography/ORTypography';
import ShowPasswordIcon from 'components/MissionCtrl/InstancesPage/InstanceDetail/ShowPasswordIcon/ShowPasswordIconContainer';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  title: PropTypes.string.isRequired,
  description: MorePropTypes.or([MorePropTypes.explicitNull, PropTypes.string]).isRequired,
  connectionString: PropTypes.string.isRequired,
  instanceId: PropTypes.string.isRequired,
};

export function UnstyledConnectItem({ classes, title, description, connectionString, instanceId }) {
  const copyButton = (
    <CopyToClipboard
      copyString={connectionString}
      copyStyles={{
        marginTop: '6px',
        marginBottom: '4px',
        backgroundColor: 'inherit',
        color: 'inherit',
        boxShadow: 'none',
      }}
      checkColor="secondary"
      size="small"
    />
  );

  return (
    <div className={classes.hostContainer}>
      <div className={classes.hostRole}>
        {description && (
          <ORTypography data-lookup="descriptionTypography">{description}</ORTypography>
        )}
      </div>
      <div className={classes.connectionStringContainer}>
        <TextField
          fullWidth
          variant="outlined"
          label={title}
          value={connectionString}
          InputLabelProps={{
            shrink: true,
            className: classes.inputLabel,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <ShowPasswordIcon instanceId={instanceId} />
                {copyButton}
              </InputAdornment>
            ),
            classes: {
              root: classes.connectionStringText,
            },
          }}
        />
      </div>
    </div>
  );
}

UnstyledConnectItem.propTypes = propTypes;

const styles = (theme) => ({
  hostContainer: {
    display: 'flex',
    flexFlow: 'column wrap',
    margin: `${theme.spacing(4)}px ${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(
      1,
    )}px`,
  },
  hostRole: {
    display: 'flex',
    margin: `${theme.spacing(1.25)}px 0 -${theme.spacing(1.25)}px 0`,
    padding: '0',
    wordBreak: 'break-all',
    paddingRight: '48px',
    textTransform: 'capitalize',
  },
  connectionStringContainer: {
    display: 'flex',
    flexFlow: 'row wrap',
  },
  connectionStringText: {
    color: theme.customColors.mediumGrey,
    fontFamily: 'Monospace, sans-serif',
    wordBreak: 'break-all',
  },
  inputLabel: {
    color: theme.customColors.black,
  },
  showPasswordIcon: {
    cursor: 'pointer',
  },
});

export default withStyles(styles)(UnstyledConnectItem);
